<template lang="pug">
  .cancel-color-issue
    SectionBlock(no-padding=true)
      transition(name="fade")
        .cancel-wrap
          .back-row
            BackButton(:url="backUrl")

          SectionTitle(text="Cancel Subscription").text-center
          ColorCrewContact
            span We're so sorry you aren't happy with your results. Reach out for one-on-one help from our licensed colorists and your next box is
              span.bold &nbsp;FREE

          .other-options
            p.other-options.color-slate.text-center.xs-f-small.lg-f-medium.max-at-tweak Or, try the following options at home...

            ActionButton(title="Explore More Shades" descr="Try something new and different" @action-btn-click="exploreMoreShades")
            ActionButton(v-if="validOffer" title="Refresh Faded Color" descr="Try a hair gloss to revive faded tones" @action-btn-click="glossOfferMethod")

          CancelSubBtn
  
</template>

<script>
  import vueCartSvc from '../../../../services/vueCartSvc';
  import vueCustomerSvc from '../../../../services/vueCustomerSvc';
  import SectionBlock from "../../SectionBlock";
  import BackButton from "../../BackButton";
  import SubInEdit from './SubInEdit';
  import SectionTitle from "../../../SectionTitle";
  import ColorCrewContact from "./ColorCrewContact";
  import CancelSubBtn from "./CancelSubBtn";
  import ActionButton from "./ActionButton";
  import { mapActions, mapState } from "vuex";
  import vueXsellSvc from "../../../../services/vueXsellSvc";
  import zendeskTag from "../../../../mixins/zendeskTag";

  export default {
    name: "EditAutoDeliveryCancelColorIssue",
    extends: SubInEdit,
    components: {
      ActionButton,
      CancelSubBtn,
      ColorCrewContact,
      SectionTitle,
      BackButton,
      SectionBlock,
    },

    mixins: [zendeskTag],

    data() {
      return {
        promoId: 2844,
        validOffer: false
      }
    },

    computed: {
      ...mapState('subscriptions', [
        'cancelData'
      ]),

      backUrl() {
        return `/dashboard/purchases/edit-auto-delivery/${this.$route.params.subId}/cancel-reasons`;
      },
    },

    methods: {
      ...mapActions([
        'notifySuccess',
        'notifyError'
      ]),

      ...mapActions('subscriptions', [
        'editAutoDeliveryChangeColorModal'
      ]),

      ...mapActions('customer', [
        'setCdata'
      ]),

      glossOfferMethod() {
        vueCustomerSvc.assignCustomerPromo({ 
          customerId: this.subInEdit.customer_id,
          promoId: this.promoId
        }).then(() => {
          let gloss = { uri: '/gloss' };
          const productCode = this.subInEdit.code;
          vueXsellSvc.getXsellItemsForProduct({ productCode })
            .then((res)=> {
              gloss = res.data.find((n) => n.product_type == 'gloss');
              //- NO notification necessary
            })
            .finally(() => {
              window.location = gloss.uri;
              this.trackEvent('Cancel flow refresh faded color', this.cancelData);
            });
          })
          .catch(() => {
            this.notifyError();
          })
      },

      exploreMoreShades() {
        this.editAutoDeliveryChangeColorModal({ subId: this.subInEdit.id, theme: 'try-it-on-modal'});
        this.trackEvent('Cancel flow explore more shades', this.cancelData);
      }
    },

    mounted() {
      if (!this.cancelData.reason.id) {
        this.$router.push({name: 'cancelReasons'});
      }

      if (this.cancelData.reason.tag) {
        this.zClick(this.cancelData.reason.tag);
      }

      vueCartSvc.validatePromoById({ promoId: this.promoId })
        .then((res) => {
          this.validOffer = res.data.hasOwnProperty('promoId');
        });
    }
  }
</script>

<style scoped lang="stylus">
  .cancel-color-issue
    .section-title
      padding-bottom 2em

    .back-row
      margin-top 1.5em
      margin-left 1em

    .other-options
      max-width 26em
      margin 0 auto
      padding 0 0.5em

      >p
        padding 3em 0 2em

      button
        width 100%
        margin-bottom 0.8em

    .cancel-sub-btn
      padding 2em 0

</style>
